"use client"

import { useAppSelector } from "../redux"

export const useSelectedVariant = () => {
  const selectedVariantId = useAppSelector(state => state.product.productDetailState.selectedVariantId)
  const variants = useAppSelector(state => state.product.design_detail.data.variants)
  return variants[selectedVariantId]
}